module.exports = __webpack_public_path__ + "static/fonts/icomoon.fb2b5df.woff";


//////////////////
// WEBPACK FOOTER
// ./static/otherIcon/fonts/icomoon.woff?b7i6dh
// module id = XGmV
// module chunks = 71